import React, { useContext } from "react";
import style from "./index.module.scss";
import { Button } from "antd";
import className from "classnames";
import { Drawer } from "antd";
import { TopicsItem } from "../../../../../../../service";
import { QuestionnaireContext } from "../../../../../../../store";
import { isTrue } from "../../../../../../../../../../Utils/filter";

interface AnswerCardModalProps {
    onClose: () => void;
    visible: boolean;
    checked: number;
    data?: TopicsItem[];
    onChange: (val: number) => void;
    onSubmit: () => void;
}

export default function AnswerCardModal({
    onClose,
    visible,
    checked,
    data,
    onChange,
    onSubmit
}: AnswerCardModalProps) {
    const { questionnaire } = useContext(QuestionnaireContext);

    function handleSubmit() {
        onSubmit();
        onClose();
    }

    function isAnswerState(id: string, questions?: TopicsItem[]) {
        let isAnswerBoolean = false;

        for (let item of questionnaire) {
            if (item.id == id) {
                if (item.isAnswer) {
                    isAnswerBoolean = true;
                    break;
                }
                isAnswerBoolean = false;
            } else {
                //id在context里找不到表示是自定义或者阅读理解类型题，questions为子题数组
                if (questions) {
                    for (let subItem of questions) {
                        if (item.id == subItem.id) {
                            if (!item.isAnswer) {
                                isAnswerBoolean = false;
                                return;
                            }
                            isAnswerBoolean = true;
                        }
                    }
                }
            }
        }
        // console.log(id,isAnswerBoolean)
        return isAnswerBoolean;
    }

    return (
        <Drawer
            placement="right"
            closable={false}
            onClose={onClose}
            visible={visible}
            getContainer={false}
            maskClosable
            className={style.root}>
            <div className={style.root}>
                <div className={style.head}>
                    <span className={style.title}>全部试题</span>
                    <div className={style.tip}>
                        <div className={style.already}>已答</div>
                        <div className={style.noAlready}>未答</div>
                    </div>
                </div>

                <div className={style.body}>
                    <ul className={style.qidList}>
                        {data &&
                            data.map((item, index) => (
                                <li
                                    key={index}
                                    onClick={() => {
                                        onChange(item.index);
                                        onClose();
                                    }}
                                    className={className(style.qidItem, {
                                        [style.answered]: isAnswerState(
                                            item.id,
                                            item.questions
                                        ),
                                        [style.current]: item.index === checked
                                    })}>
                                    {isTrue(item.requiredFlag) && (
                                        <span className="required_overflow" />
                                    )}
                                    {item.index}
                                </li>
                            ))}
                    </ul>
                </div>

                <div className={style.footer}>
                    <Button
                        type="primary"
                        block
                        className={style.btn}
                        onClick={() => handleSubmit()}>
                        提交问卷
                    </Button>
                </div>
            </div>
        </Drawer>
    );
}
